<div class="careers-email">
  <sca-card-view cardTitle="Email">
    <form #f="ngForm" novalidate>
      <div class="sc-form">
        @if (!noTemplate) {
          <div class="sc-form-row">
            <!--Email Template Id-->
            <div class="sc-form-control">
              <sabis-combobox2 [(ngModel)]="this.email.emailTemplateId"
                [required]="true"
                (ngModelChange)="onEmailTemplateChanged()"
                [scItems]="emailTemplates"
                [disabled]="isDisabled || isDisabledInternal"
                name="emailTemplates"
                scLabel="Email Template"
                scValueField="emailTemplateId"
              scDisplayField="name"></sabis-combobox2>
            </div>
          </div>
        }

        <div class="sc-form-row">
          <!--From -->
          <div class="sc-form-control">
            <sabis-ngx-input scType="text"
              [(ngModel)]="this.email.fromEmail"
              disabled="this.email.emailTemplateId || isDisabled || isDisabledInternal"
              required
              maxlength="150"
              name="fromEmail"
            scLabel="From"></sabis-ngx-input>

          </div>
        </div>

        <div class="sc-form-row">
          <!--To -->
          <div class="sc-form-control">
            @if (showRecipient) {
              <sabis-ngx-input scType="text"
                [(ngModel)]="this.email.toEmail"
                [disabled]="isDisabled || isDisabledInternal"
                required
                maxlength="150"
                name="toEmail"
              scLabel="To"></sabis-ngx-input>
            }

          </div>
        </div>

        @if (showEmailCC) {
          <div class="sc-form-row">
            <!-- CC -->
            <div class="sc-form-control">
              <sabis-ngx-input scType="text"
                [(ngModel)]="this.email.ccEmail"
                [disabled]="isDisabled || isDisabledInternal"
                maxlength="150"
                name="ccEmail"
              scLabel="CC"></sabis-ngx-input>
            </div>
          </div>
        }

        <div class="sc-form-row">
          <!-- Subject-->
          <div class="sc-form-control">
            <sabis-ngx-input scType="text"
              [(ngModel)]="this.email.subject"
              [disabled]="isDisabled || isDisabledInternal"
              required
              maxlength="100"
              name="subject"
            scLabel="Subject"></sabis-ngx-input>

          </div>
        </div>
        <!-- Sending Period: changed from drop down (values {"send now", "schedule for later"}) to checkbox ("schedule for later")-->
        @if (showScheduleForLater) {
          <div class="sc-form-row">
            <div class="sc-form-control">
              <sabis-ngx-checkbox [(ngModel)]="this.email.isScheduledForLater"
                [disabled]="isDisabled || isDisabledInternal"
                name="isScheduledForLater"
                scLabel="Schedule For Later">
              </sabis-ngx-checkbox>
            </div>
          </div>
        }
        <!-- Priority -->
        <!--<div class="sc-form-control">
        <sabis-combobox2 [(ngModel)]="this.email.priorityId"
          [required]="true"
          [scItems]="priorities"
          [disabled]="isDisabledInternal"
          name="priority"
          scLabel="Priority"
          scValueField="itemId"
        scDisplayField="name"></sabis-combobox2>
      </div>-->

      <div class="sc-form-row">

        <!-- Scheduled Date -->
        @if (this.email.isScheduledForLater) {
          <div class="sc-form-control">
            <sabis-ngx-datepicker name="scheduledDate" scLabel="Scheduled Date" [disabled]="isDisabled || isDisabledInternal"
            [(ngModel)]="this.email.scheduledDate" [min]="minDate" [max]="maxDate"></sabis-ngx-datepicker>
          </div>
        }

        <!--<div class="sc-form-control">-->
        <!-- time -->
        <!--<sabis-ngx-input scType="time"
        [(ngModel)]="this.email.scheduledTime"
        name="scheduledTime" scLabel="Scheduled Time" required>
      </sabis-ngx-input>
    </div>-->


  </div>
  @if (canAttachDocuments) {
    <div class="sc-form-row">
      <div class="sc-form-control">
        <sabis-ngx-filepicker [uploader]="uploader"
          [label]="'Attach Files'"
          [files]="attachedFiles"
          [isEditable]="!isDisabled"
          [isMultiple]="true"
          [directoryPath]="attachmentFileDirectoryPath"
        (fileChanged)="onModelChange($event)"></sabis-ngx-filepicker>
      </div>
    </div>
  }
  <div class="sc-form-row">
    <!-- body -->
    <sabis-texteditor2 disabled="this.email.emailTemplateId || isDisabled || isDisabledInternal" [(ngModel)]="this.email.body" name="body" required
    maxlength="4000" [scMaxLength]="4000" scLabel="Body" class="careers-email__body"></sabis-texteditor2>
  </div>

</div>
</form>
</sca-card-view>
</div>
